var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-carousel-main"},[_c('div',{staticClass:"container"},[_c('vCarousel',{attrs:{"carousel_data":_vm.sliderItems,"interval":2000}}),_c('vCarouselItem')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }